// This import loads the firebase namespace along with all its type information.
import ApprovedSeries from './approved-series-model'

export async function load_approvedSeriess(): Promise<ApprovedSeries[]> {
  throw 'Not implemented'
}

export async function delete_approvedSeries(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_approvedSeries(): Promise<ApprovedSeries> {
  throw 'Not implemented'
}
